import {
    DEFAULT_LOCALE,
    applyConsentTranslations,
    type ConsentTranslationRow,
    type SupportedLocale,
} from "@patient-watch/i18n";
import type { ConsentViewT } from "@/types/database/consents";

export interface ConsentBodyCopy {
    consent_body_id: string;
    consent_name: string;
    summary_text: string | null;
    attestation_text: string | null;
    document_url: string | null;
}

export function consentHasSignedCopy(consent: ConsentViewT): boolean {
    const signatures = Array.isArray(consent.signatures) ? consent.signatures : [];
    return signatures.some((signature) => Boolean(signature.signed_at));
}

/** Overlay body + locale copy onto an unsigned consent. Signed rows stay frozen. */
export function applyUnsignedConsentOverlay(
    consent: ConsentViewT,
    locale: SupportedLocale,
    body: ConsentBodyCopy | null,
    translation: ConsentTranslationRow | null | undefined
): ConsentViewT {
    if (consentHasSignedCopy(consent)) {
        return consent;
    }

    if (!body) {
        return consent;
    }

    const canonical = {
        ...consent,
        consent_body_id: body.consent_body_id,
        consent_name: body.consent_name,
        summary_text: body.summary_text,
        attestation_text: body.attestation_text,
        document_url: body.document_url,
    };

    if (locale === DEFAULT_LOCALE) {
        return canonical;
    }

    return applyConsentTranslations(canonical, locale, translation);
}
